import { useMemo } from 'react';
import { AgGridReact } from 'ag-grid-react';
import { AllCommunityModule, ModuleRegistry, themeQuartz } from 'ag-grid-community';
import { getToken, useTheme } from '../../utils/themeTokens';

// Register all Community features
ModuleRegistry.registerModules([AllCommunityModule]);

const AGGrid = ({ rowData, colDefs }) => {
    const mode = useTheme(); // rebuild grid theme when light/dark flips

    const theme = useMemo(() => themeQuartz.withParams({
        backgroundColor: getToken('--card', '#ffffff'),
        foregroundColor: getToken('--foreground', '#101418'),
        textColor: getToken('--foreground', '#101418'),
        headerBackgroundColor: getToken('--muted', '#f0f2f5'),
        headerTextColor: getToken('--muted-foreground', '#5b6572'),
        borderColor: getToken('--border', '#e3e7ec'),
        headerColumnResizeHandleColor: getToken('--border-strong', '#cdd4dc'),
        accentColor: getToken('--primary', '#059669'),
        rowHoverColor: getToken('--card-hover', '#fbfcfd'),
        fontFamily: getToken('--font-sans', 'Inter, sans-serif'),
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }), [mode]);

    return (
        <AgGridReact
            theme={theme}
            rowData={rowData}
            columnDefs={colDefs}
            pagination={true}
            paginationPageSize={20}
            rowHeight={52}
            headerHeight={52}
        />
    );
};

export default AGGrid;
